import ProductSummaryNameProvider from './hooks/useProductSummaryName';

import { ProductSummaryNameProps } from './@types/ProductSummaryNameProps';
import NameContainer from './handles/NameContainer';
import ProductNameContainer from './handles/ProductNameContainer';
import ProductBrand from './handles/ProductBrand';
import ProductReference from './handles/ProductReference';
import ProductNameComponent from './handles/ProductName';

const ProductSummaryName = (props: ProductSummaryNameProps) => {
	return (
		<ProductSummaryNameProvider {...props}>
			<NameContainer>
				<ProductNameContainer>
					<ProductBrand />
					<ProductNameComponent />
					{props.showFieldsProps.showProductReference && <ProductReference />}
				</ProductNameContainer>
			</NameContainer>
		</ProductSummaryNameProvider>
	);
};

export default ProductSummaryName;
